import request from '@/utils/request'

let getLastRecord=(data)=>request.post('/api/notifyLog/getLastNotify',data,{'content-type':'multipart/form-data'})
let getRecords=(data)=>request.post('/api/notifyLog/getNotifyLogs',data)
let resendRecord=(data)=>request.get('/api/notify/sendLastCmd',data)

export default {
  getLastRecord,
  getRecords,
  resendRecord
}